import React from 'react';
import '../../styles/onboardingFlow/mobileLogoCard/mobileLogoSlide2.scss';
import sparkleIcon from '../../assets/onboarding/slides/slide2/Sparkle.svg';
import window1 from '../../assets/onboarding/slides/slide2/window1.svg';
import window2 from '../../assets/onboarding/slides/slide2/window2.svg';
import window3 from '../../assets/onboarding/slides/slide2/window3.svg';

const MobileLogoSlide2: React.FC = () => {
  return (
    <div className='mobileLogoSlide2'>
      <div className='mobileLogoSlide2__content'>
        <div className='mobileLogoSlide2__sparkle'>
          <img src={sparkleIcon} alt='Sparkle' />
        </div>
        <div className='mobileLogoSlide2__windows'>
          <div className='mobileLogoSlide2__window mobileLogoSlide2__window--1'>
            <img src={window1} alt='Report Window 1' />
          </div>
          <div className='mobileLogoSlide2__window mobileLogoSlide2__window--2'>
            <img src={window2} alt='Report Window 2' />
          </div>
          <div className='mobileLogoSlide2__window mobileLogoSlide2__window--3'>
            <img src={window3} alt='Report Window 3' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileLogoSlide2;
